import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/lib/api-client'
import { supabase } from '@/lib/supabase'

interface CreateHouseholdResponse {
  householdId: string
}

export function useCreateHousehold() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (name: string) =>
      apiClient.post<CreateHouseholdResponse>('/api/v1/households', { name }),
    onSuccess: async () => {
      // Force a server-side token refresh so the JWT picks up the new
      // household_id and role claims from custom_access_token_hook
      await supabase.auth.refreshSession().catch(() => {})
      queryClient.invalidateQueries({ queryKey: ['auth', 'session'] })
    },
  })
}
